import { InboxArrowDownIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { appPaths } from "../../../shared/routing/appPaths";
import { formatDateTime } from "../../../shared/formatting/dateTimes";
import { openHostOffers, useHostOfferInbox } from "./incomingHostOffers";

/**
 * What waits for the user to decide, at the top of the Threads sidebar (Q-60): host offers
 * made to them, each opening the offer to take it over or decline; and requests for their
 * role (F55), each opening the Thread, whose hosting line hands it over or declines. Nothing
 * shows without either.
 */
export default function HostOfferInbox() {
  const { t, i18n } = useTranslation();
  const offers = openHostOffers(useHostOfferInbox());
  if (offers.length === 0) {
    return null;
  }
  return (
    <section className="app-card space-y-1.5 p-2.5" aria-label={t("threads.inbox.title")}>
      <h3 className="app-title flex items-center gap-1.5 text-xs font-semibold">
        <InboxArrowDownIcon className="h-4 w-4" aria-hidden="true" />
        {t("threads.inbox.title")}
      </h3>
      <ul className="space-y-1">
        {offers.map((offer) => (
          <li key={offer.offerId} className="text-xs">
            {offer.state === "requested" ? (
              <Link to={appPaths.thread(offer.threadId)} className="app-action-link block">
                {t("threads.inbox.hostRequest", { from: offer.toDisplayName, title: offer.threadTitle })}
              </Link>
            ) : (
              <Link to={appPaths.threadHostOffer(offer.threadId, offer.offerId)} className="app-action-link block">
                {t("threads.inbox.hostOffer", { from: offer.fromDisplayName, title: offer.threadTitle })}
              </Link>
            )}
            <span className="app-text-muted block text-[11px]">
              {t("threads.inbox.expires", { expires: formatDateTime(offer.expiresAt, i18n.resolvedLanguage) })}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
